import React, { Component } from 'react';
import { debounce } from 'lodash/fp';
import { Button } from 'ui';

const WAIT = 300;

class SearchBox extends Component {
  state = {
    value: '',
  };

  clearSearch = () => {
    this.setState({ value: '' }, () => this.props.onSubmit(''));
  };

  handleSubmit = debounce(WAIT)(() => {
    if (this.props.query !== this.state.value) {
      this.props.onSubmit(this.state.value);
    }
  });

  handleChange = e => {
    this.setState({ value: e.target.value }, () => {
      if (this.state.value === '' || this.props.query === '') {
        this.props.onSubmit(this.state.value);
      } else {
        this.handleSubmit();
      }
    });
  };

  render() {
    const hasValue = this.props.query || this.state.value;
    const placeHolderText = this.props.currentSessionId
      ? t('in_person_training.event_overview.attendance.search_guests')
      : t(
          'in_person_training.event_overview.attendance.invite_and_search_individuals',
        );

    return (
      <div className="EventAttendanceSearchBox">
        {hasValue && (
          <Button
            smaller
            className="EventAttendanceSearchBox-clearBtn"
            onClick={this.clearSearch}
          >
            {t('common.clear')}
          </Button>
        )}
        <input
          className="EventAttendanceSearchBox-input NewInput NewInput--lightestGray NewInput--fw llui-text llui-text-body trk_input_learning_invite-attendees"
          value={this.state.value}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          placeholder={placeHolderText}
        />
      </div>
    );
  }
}

export default SearchBox;
